/** Build + apply consultation details bootstrap for instant show-page UX. */

export function buildConsultationDetailsBootstrap(consult, consultationId) {
  if (!consult || consultationId == null) return null;

  const status = consult.status;
  const type = consult.type;

  return {
    consultationId: String(consultationId),
    number: String(consult.consultation_number || consult.number || "").trim(),
    subject: consult.subject || "",
    description: consult.description || "",
    date: consult.date || consult.created_at || "",
    statusId: status?.id ?? consult.status_id ?? null,
    statusTitle: status?.title || null,
    payment_status: consult.payment_status ?? null,
    type:
      type && typeof type === "object"
        ? type
        : type != null && type !== ""
          ? { id: type }
          : null,
    activity: consult.activity || null,
    offer_before_tax: Number(
      consult.offer_before_tax ?? consult.offer_price ?? 0,
    ),
    tax_percent: Number(consult.tax_percent ?? 15),
    method: consult.oppointment_method || consult.method || "none",
    method_date: consult.oppointment_date || consult.method_date || null,
    method_time: consult.oppointment_time || consult.method_time || null,
    negotiations_count: Number(consult.negotiations_count ?? 0),
    client_name:
      consult.client_name ||
      consult.user?.name ||
      consult.owner_name ||
      "",
    client_company: consult.client_company || consult.company_name || "",
  };
}

export function applyConsultationDetailsBootstrap(form, boot) {
  if (!boot || !form) return false;

  if (boot.number) form.number = boot.number;
  if (boot.subject) form.subject = boot.subject;
  if (boot.description != null) form.description = boot.description;
  if (boot.date) form.date = boot.date;
  if (boot.payment_status != null) form.payment_status = boot.payment_status;

  if (boot.statusId != null) {
    form.status = boot.statusTitle
      ? { id: Number(boot.statusId), title: boot.statusTitle }
      : { id: Number(boot.statusId) };
  }

  if (boot.type) form.type = boot.type;
  if (boot.activity) form.activity = boot.activity;

  form.offer_before_tax = Number(boot.offer_before_tax ?? 0);
  form.tax_percent = Number(boot.tax_percent ?? 15);
  form.method = boot.method || "none";
  form.method_date = boot.method_date || null;
  form.method_time = boot.method_time || null;
  form.negotiations_count = Number(boot.negotiations_count ?? 0);

  if (boot.client_name) form.client_name = boot.client_name;
  if (boot.client_company) form.client_company = boot.client_company;

  return true;
}

export function navigateToConsultationDetails(
  router,
  consult,
  routeName = "consultations.show",
) {
  const bootstrap = buildConsultationDetailsBootstrap(consult, consult.id);
  router.push({
    name: routeName,
    params: { id: consult.id },
    state: bootstrap ? { consultationDetailsBootstrap: bootstrap } : {},
  });
}
